module.exports = __webpack_public_path__ + "img/logo.a5c46e16.png";